export default "__VITE_ASSET__22b04102__"